module.exports = "//img1.rrcimg.com/_next/static/src/assets/zz_3Jpwz.png";